export default "__VITE_ASSET__9ab89774__"